import React from "react";
import { useNavigate } from "react-router-dom";
import { RouterPath } from "../../../assets/dictionary/RouterPath";
import { Button } from "../../../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/card";
import { CheckCircle } from "lucide-react";

export default function PasswordChanged() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-4 app-page-gradient">
      <div className="w-full max-w-md">
        <Card className="glass-card border-muted shadow-2xl">
          <CardHeader className="text-center space-y-4">
            <div className="w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="h-8 w-8 text-green-600 dark:text-green-400" />
            </div>
            <CardTitle className="text-2xl font-bold text-high-contrast">Mot de passe modifié</CardTitle>
            <CardDescription className="text-muted-foreground">
              Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button className="w-full" onClick={() => navigate(RouterPath.LOGIN)}>
              Se connecter
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
